<template>
  <ContainerComponent v-if="radio">
    <section class="view-parent">
      <!-- Below was temporary v-if was temporary fast solution -->
      <template v-if="radio.hasOwnProperty('benefits')">
        <transition appear name="fade2">
          <LandscapeImage
            v-if="radio.hasOwnProperty('landscapeImagePath')"
            v-show="maximized"
            :name="radio.name"
            :section="prefix"
            :file-name="radio.landscapeImagePath"
            :radio="radio"
            @minimize="minimizeLandscape()"
          />
        </transition>
        <ProductHeader
          v-if="currentRadio"
          class="product-header-parent"
          :name="currentRadio.name"
          :category="currentRadio.category"
        />
        <SubproductTabComponent
        v-if="hasSubproducts && currentRadio"
        :section="section"
        :radio="radio"
        :currentRadio="currentRadio"
        :subproducts="subproducts"
        />
        <ProductInformationComponent v-if="currentRadio"
          :section = section
          :radio = currentRadio
          :prefix = prefix
        />
        <ProductsBottomNavComponent v-if="currentRadio"
          :prefix="prefix"
          :radio="radio"
          :section="section"
          :radios="navRadios"
          :base-url="baseUrl"
          :currentRadio="currentRadio"
        />
      </template>
      <template v-else>
        <div class="no-data-tag">No data added</div>
        <div class="bottom-icon-placeholder">
          <div>
            <div class="img-holder home-ico single-product-view-icons">
              <i
                class="icon icon-arrow-left text-xl clickable"
                @click="goBack($event)"
              />
            </div>
          </div>
        </div>
      </template>
    </section>
  </ContainerComponent>
</template>

<script>
import LandscapeImage from '@/components/landscape.vue';

import ProductInformationComponent from '@/components/ProductInformationComponent.vue'
import ProductsBottomNavComponent from '@/components/ProductsBottomNavComponent.vue';
import ContainerComponent from '@/components/ContainerComponent';
import SubproductTabComponent from '@/components/SubproductTabComponent.vue';
import { ProductHeader } from '@/components';
import { mapGetters } from 'vuex';
import readIsManaVersionFlag from '@/shared/manaVersionHelper';
import axios from 'axios';
import { getStaticUrl } from '@/helpers';
import StaticUrlService from '@/services/staticUrlService';

export default {
  name: 'Singleproduct',
  components: {
    ContainerComponent,
    LandscapeImage,
    ProductInformationComponent,
    ProductsBottomNavComponent,
    ProductHeader,
    SubproductTabComponent,
  },
  props: {
    section: Object,
    prefix: String,
    miniTransiitionLoading: false,
    baseUrl: String,
    useStoreSection: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      maximized: false,
      currentRadio: null,
      radio: null
    };
  },
  computed: {
    ...mapGetters(['activeCategories']),
    staticUrl () {
      return getStaticUrl(null, this.$route.name);
    },
    customSelectionRadios() {
      return this.activeCategories.includes(this.section.name)
        ? this.$store.state.radios.filter(radio => radio.sectionName === this.section.name).filter(el =>
            this.$store.state.customSelectionCheckedProducts[
              this.section.name
            ].includes(el.productId)
          )
        : this.$store.state.radios.filter(radio => radio.sectionName === this.section.name && !radio.parentId);
    },
    navRadios() {
      if (this.useStoreSection) {
        const section = this.$store.state.radios.find(
          section => section.prefix === this.prefix
        );
        const filteredFamilyProducts = this.$store.state
          .customSelectionCheckedProducts[section.name];
        const filteredRadios = section.radios
          .filter(radio => filteredFamilyProducts.indexOf(radio.productId) !== -1)
          .map(radio => ({ ...radio, section: this.prefix }));
        return filteredRadios;
      } else {
        return this.customSelectionRadios;
      }
    },
    hasSubproducts() {
      return this.$store.state.radios.filter(radio => radio.parentId === this.radio.id).length > 0;
    },
    subproducts() {
      return this.$store.state.radios.filter(radio => radio.parentId === this.radio.id);
    }
  },
  async mounted() {
    const fullStaticUrl = await StaticUrlService.getFullStaticUrl(null, this.$route.name);
    axios.get(`${fullStaticUrl}productData.json?` + Date.now()).then(result => {
      this.$store.commit(
        'radios',
        result.data.filter(x => x.isMana == readIsManaVersionFlag())
      );
      const temp = this.$store.state.radios.filter(radio => radio.sectionName === this.section.name).find(radio => radio.fileName === this.$route.params.product);

      if(!this.$route.params.subproduct) {
        this.currentRadio = temp;
        this.radio = temp;
      }
      else {
        const fileName = this.$route.params.subproduct;
        this.radio = temp;
        this.currentRadio = this.subproducts.find(subproduct => subproduct.fileName === fileName);
      }
    });
  },

  watch: {
    '$route.params.product': function(val) {
      if(val) {
        this.radio = this.$store.state.radios.filter(radio => radio.sectionName === this.section.name).find(radio => radio.fileName === val);
        this.currentRadio = this.radio;
      }
    },
    '$route.params.subproduct': function(val) {
      if(!val) {
        this.currentRadio = this.radio;
      }
      else {
        this.currentRadio = this.subproducts.find(subproduct => {
          return subproduct.fileName === val;
        });
      }
    }
  },

  methods: {
    maximizeLandscape() {
      this.maximized = true;
    },
    minimizeLandscape() {
      if (this.maximized) {
        this.maximized = false;
      }
    },
    goBack() {
      if (this.$route.query.from && this.$route.query.from === 'showcase') {
        this.$route.push({ name: 'showcase' });
      } else {
        this.$router.go(-1);
      }
    },
    changeCurrentProduct(clickedSubProductId) {
      if(clickedSubProductId !== this.currentRadio.id) {
        if(clickedSubProductId === this.radio.id) {
          this.$router.push({ name: this.prefix, params: { product: this.radio.fileName } });
        }
        else {
          let subproduct = this.radio.subproducts.find(subproduct => {
            return subproduct.id === clickedSubProductId;
          });

          this.$router.push({
            name: this.prefix,
            params: { product: this.radio.fileName, subproduct: subproduct.fileName }
            });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '../assets/common.less';

.button-group {
  margin-left: 1.5rem;
}

.no-data-tag {
  font-size: @font-size-xl;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.product-header-parent {
  display: inline-block;
  padding: @space-xl @space-xl @space-xl @space-xl;
}

/* TRANSITIONS */
.fade2-enter-active,
.fade2-leave-active {
  transition: opacity 0.5s;
}
.fade2-enter, .fade2-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.expandfade-enter-active {
  animation: grow 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;
}
.expandfade-leave-active {
  animation: shrink 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;
}

.implodefade-leave-active {
  animation: gone 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;
}
.implodefade-enter-active {
  animation: appear 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;
}
/* ANIMATIONS */
@keyframes grow {
  0% {
    width: 0%;
    opacity: 0;
  }
  100% {
    width: 30%;
    opacity: 1;
  }
}

@keyframes shrink {
  to {
    width: 0%;
    opacity: 0;
  }
}

@keyframes appear {
  0% {
    width: 0%;
    opacity: 0;
  }
  70% {
    opacity: 1;
  }
  100% {
    width: 30%;
    opacity: 1;
  }
}

@keyframes gone {
  0% {
    width: 30%;
    opacity: 1;
  }
  30% {
    opacity: 0;
  }
  100% {
    opacity: 0;
    width: 0%;
  }
}

.thescene {
  touch-action: pinch-zoom;
}

/* MAIN*/
.view-parent {
  display: flex;
  padding: @space-large @space-large @space-large @space-xxl;
  background-color: @gray-09;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
}

/* Foooter */
.bottom-icon-placeholder {
  pointer-events: none; /* Deactivating so that its click through (children has pointer events auto) */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-left: @space-xl;
  padding-right: @space-xl;
  padding-bottom: @space-base;

  .image-ico {
    margin-left: @space-large;
  }
  .home-ico {
    padding: 0.1rem;
    vertical-align: bottom;
  }
  .selectedIcon {
    background-color: @blue;
  }
  /* Icons */
  .img-holder {
    display: inline-block;
    padding: 0.2rem;
    cursor: pointer;
  }
  .single-product-view-icons {
    width: 1.7rem;
    height: 1.7rem;
    pointer-events: auto;
  }

  .logout-ico {
    display: inline-block;
    margin-right: @space-base;
  }
}
/* GENERAL */

.p-tag {
  margin: 0px;
}
</style>
